import * as React from 'react';
import * as Session from '../../service/Session';
import * as RB from 'react-bootstrap';
import * as TF from '../../service/tradeflow';
import * as DTO from '../../service/DTOs';

import * as ChatState from './ChatState';
import { ChatUserList } from './ChatUserList';

import { SpinnerBlock } from './../shared/effects/Spinners'

const iconSpinner = <SpinnerBlock />


type ImpactorChatListProps = {
    syshdr: DTO.SystemHeader;
    user: Session.UserState,
    xsrfToken?: string,
    personalState?: Session.PersonalState,
    //idchat?: number,
    shareChatId?: number,
    appId: number,
    new_messages: DTO.AgentTextMessage[]
};

type ImpactorChatListState = {
    chatusers: DTO.ChatUserState[];
    holdFocus: boolean;
    selectedchat: DTO.ChatState;
    isLoading: boolean;

    //syshdr: DTO.SystemHeader;
    //user: Session.UserState,
    //xsrfToken?: string,
    //personalState?: Session.PersonalState,
    //idchat?: number
};


export class ImpactorChatList extends React.Component<ImpactorChatListProps, ImpactorChatListState> {

    constructor(props: ImpactorChatListProps) {
        super(props);

        this.state = {
            ...{ chatusers: [], isLoading: true }, ...{ holdFocus: false }, ...{
                selectedchat: { IdChat: props.shareChatId, title: '-', privatechatuser: undefined }
            }
        };

    }

    processSysUsers(usrs: Session.PersonalState[]) {
        //let filtered = Object.assign([], this.state.chatusers);

        const chatUsers = usrs.map((el) => { const chatUser: DTO.ChatUserState = { personalState: el, connectStatus: 'Offline' }; return chatUser; });
        let filtered = chatUsers.filter(x => x.personalState.idperson != (this.props.user.personalState ? this.props.user.personalState.idperson : 0));

        //filtered.unshift(...chatUsers);

        this.setState({
            chatusers: filtered,
            isLoading: false
            //allHistoryLoaded: !(messages.length >= ChatState.batchSize)
        });

        return {};
    }

    fetchChatUsers() {
        this.setState({
            isLoading: true
        });

        TF.PublishCommandSysUsers(this.props.appId);
    }


    componentDidMount() {
        TF.DataProcessBinding(this, { type: 'SYS.MSG.sysusers', delegate: (usrs: Session.PersonalState[]) => this.processSysUsers(usrs) });
        this.fetchChatUsers();
        this.handleSelectContext('', this.state.selectedchat);
    }

    componentWillUnmount() {
        TF.DataProcessUnBinding(this, { type: 'SYS.MSG.sysusers', delegate: (usrs: Session.PersonalState[]) => this.processSysUsers(usrs) });
    }

    handleSelectContext(locatorId: string, chat: DTO.ChatState) {
        this.setState({
            selectedchat: chat
        });


        let uiCtx: DTO.UserInteractionContext = {
            selected_cmp: this,
            selected_locatorId: '' + locatorId
        }
        TF.PublishCommand('COMMAND.UI.UserInteractionCtx', uiCtx);

        if (locatorId && chat) {
            let cmd: TF.SelectChatCommand = {
                chat: chat
            }

            TF.PublishCommand('COMMAND.SelectChat', cmd);
        }
    }

    render() {
        return (
            <div className= "otc-user-list">
                <div>Чаты</div>

                {this.state.isLoading ?
                    <div style={{ minHeight: '100px' }}>{iconSpinner}</div>
                    : <ChatUserList {...this.props} {...this.state} chatSelected={this.handleSelectContext.bind(this)} showShareChat={true} sortOrder='lastmsgtime' />
                }
                </div>
        );
    }
}

